import type { ReactNode } from 'react';

import type { ActionAvailability } from './types';

export const enabled = (): ActionAvailability => ({ status: 'enabled' });

export const disabled = (reason: ReactNode): ActionAvailability => ({
  status: 'disabled',
  reason,
});

export const hidden = (reason?: string): ActionAvailability => ({
  status: 'hidden',
  reason,
});

/**
 * A reason as plain text, for tooltips, aria labels and other string-only
 * slots. Undefined when the reason is markup, which those slots can't show.
 */
export const getReasonText = (reason: ReactNode): string | undefined =>
  typeof reason === 'string' ? reason : undefined;
